import script from "./ReportPageCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportPageCourse.vue?vue&type=script&setup=true&lang=js"

import "./ReportPageCourse.vue?vue&type=style&index=0&id=7c4a9955&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4a9955"]])

export default __exports__